import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelRevenueReality = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Revenue Reality";
  const lines = stripTitleLines(cleanLines(markdown));
  const bullets = toBullets(lines);
  let paragraphs = bullets.length ? [] : toParagraphs(lines);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Funnel Insight"
      sections={[
        {
          title: "Signal Summary",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelRevenueReality;
